export const aiConfig = {
  gemini: {
    apiKey: import.meta.env.VITE_GEMINI_API_KEY,
    model: 'gemini-2.0-flash-exp',
  },
  openai: {
    apiKey: import.meta.env.VITE_OPENAI_API_KEY,
    model: 'gpt-4o',
  },
  anthropic: {
    apiKey: import.meta.env.VITE_ANTHROPIC_API_KEY,
    model: 'claude-sonnet-4',
  },
  perplexity: {
    apiKey: import.meta.env.VITE_PERPLEXITY_API_KEY,
    model: 'sonar-pro',
  },
  // Copilot uses Azure OpenAI
  copilot: {
    apiKey: import.meta.env.VITE_OPENAI_API_KEY,
    model: 'gpt-4o',
  },
};

export type AISystem = 'gemini' | 'openai' | 'anthropic' | 'perplexity' | 'copilot';

export const AI_SYSTEMS: { id: AISystem; name: string; enabled: boolean; description?: string }[] = [
  { id: 'gemini', name: 'Google Gemini', enabled: true, description: 'Active' },
  { id: 'openai', name: 'ChatGPT', enabled: false, description: 'API key required' },
  { id: 'anthropic', name: 'Claude', enabled: false, description: 'API key required' },
  { id: 'perplexity', name: 'Perplexity', enabled: false, description: 'API key required' },
  { id: 'copilot', name: 'Microsoft Copilot', enabled: false, description: 'API key required' },
];
